import {removeFromShoppingCart, getCartFromLocalStorage} from './shopping-cart-utils.js';

/**
 * Shopping cart indicator module
 */
class ShoppingCartIndicator {
  /**
   * @constructor
   * @param {HTMLElement} element element to bind to
   */
  constructor(element) {
    this._element = element;
    this._amountElement = this._element.querySelector('.cart-amount');

    this._update();
    this._cartUpdateListener = this._update.bind(this)

    window.addEventListener('cartUpdate', this._cartUpdateListener);
  }

  /**
   * Return vehicle availability by checking are vehicles sold or not from Stage cars database.
   * If all vehicles in the car are sold false is returned if not true is returned.
   * In a case of a communication error true is returned.
   * 
   * @param {object} cartData - Cart data from session storage
   * @returns {boolean} true if any vehicles are available, false if not
   */
  async checkVehicleAvailability(cartData) {
    try {
      const ids = cartData.items.map( item => item.id ).join(',');
      
      const response = await fetch(`/stage-ajax/api/v1/vehicle/status/stage/${ids}/`, {
        method: 'GET',
        headers: { Authorization: 'stage-api-public' },        
      });
  
      const statuses = await response.json();

      // Remove shopping cart listener to prevent event loop, each removeFromShoppingCart will trigger cartUpdate event.
      // That will trigger _update method and this method again.
      window.removeEventListener('cartUpdate', this._cartUpdateListener);

      // Remove sold vehicles from shopping cart
      statuses.forEach( status => {
        if( status.sold ) {
          removeFromShoppingCart( status.license );
        }        
      });

      // Add shopping cart listener back
      window.addEventListener('cartUpdate', this._cartUpdateListener);

      return statuses.some( status => status.sold === false );
    } catch( error ) {
      return true;
    }
  }

  /**
   * Update shopping cart item amount
   */
  async _update() {
    // Get shopping cart data from local storage
    const cartData = getCartFromLocalStorage();
    const cartAmount = cartData?.amount;

    if (cartAmount > 0) {
      const anyVehicleAvailable = await this.checkVehicleAvailability(cartData); 

      if(anyVehicleAvailable) {
        this._amountElement.dataset.amount = cartAmount < 10 ? cartAmount : '9+';
        this._element.classList.add('has-items');
      } else {
        this.showNowItems();
      }
    } else {
      this.showNowItems();
    }
  }

  showNowItems() {
    this._amountElement.dataset.amount = 0;
    this._element.classList.remove('has-items');
  }

  static init() {
    document.querySelectorAll('.shopping-cart-indicator').forEach(element => {
      new ShoppingCartIndicator(element);
    });
  }
}

export default ShoppingCartIndicator;
